export const getCitiesByRegion = (list, value) =>
  list.find((i) => i.region === value)?.cities ?? [];
